import React from 'react';

import { buildColumn, EditableColumnConfig } from '~components/table-view';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

import DayDisplay from './DayDisplay';

const columnsFactory = () => {
  const columnsList: EditableColumnConfig[] = [
    {
      id: 'date',
      header: 'Day',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: boolean, row: any) => {
            if (!row) return null;
            const { date } = row.original ?? row;
            return React.createElement(DayDisplay, { date });
          },
        },
      },
    },
    {
      id: 'user.full_name',
      header: 'Worker',
      type: 'text',
    },
    {
      id: 'client.full_name',
      header: 'Client',
      type: 'text',
    },
    {
      id: 'actions',
      header: '',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: never, row: any) => {
            if (!row) return null;
            const userId = row.original?.user?.id ?? row.user?.id;
            return React.createElement(WorkerFocusAction, {
              userId,
            });
          },
        },
      },
    },
  ];

  return columnsList.map(buildColumn);
};

export default columnsFactory;
